import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Image,
	TouchableOpacity,
	Linking,
	Switch,
} from "react-native";
import { NavigationActions } from "react-navigation";
import { translate } from "react-i18next";
import range from "lodash.range";
import { get, post } from "api";
import {
	ControlPanelIP,
	ControlPanelPostIP,
	MODE,
	AWS as AWSConfig,
	AppURL,
} from "utils/config";

import AWS from "aws-sdk/dist/aws-sdk-react-native";

import { push, reset } from "utils/navigation";
import { signUp, login, refresh } from "utils/awsAuth";
import { TextField } from "components/third-party/Textfield";
import ViewScroll from "components/ViewScroll";
import BackgroundImage from "components/BackgroundImage";
import Text from "components/StyledText";
import Checkbox from "components/Checkbox";
import Header from "components/Header";
import Button from "components/Button";
import Textfield from "components/Textfield";
import Select from "components/Select";

import * as x from "../../styles/css";

class DeviceSetting extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;

	constructor(props) {
		super(props);

		this.state = {
			deviceId: "",
			inputs: {
				S1: '',
				S2: '',
				S3: '',
				S4: '',
				S5: '',
				S6: '',
				S7: '',
				SA: '',
				SF: '',
				SE: '',
			},
			loading: false,
		};
	}

	componentDidUpdate(prevProps, prevState) {
	}

	componentDidMount() {
		let userData = [];
		if(Platform.OS !== "web"){
			// should load using react-native memory
		} else {
			// load from localStorage
			let shadowDetails = JSON.parse(localStorage.getItem("shadowDetails"));
			console.log("Device Settings - shadowDetails retrieved. ", shadowDetails);

			this.setState({
				deviceId: localStorage.getItem("deviceId").replace(/"/g,''),
				inputs: {
					S1: shadowDetails.S1, // ? shadowDetails.S1 : "0",
					S2: shadowDetails.S2, // ? shadowDetails.S2 : false,
					S3: shadowDetails.S3, // ? shadowDetails.S3 : "1",
					S4: shadowDetails.S4, // ? shadowDetails.S4 : false,
					S5: shadowDetails.S5, // ? shadowDetails.S5 : "0",
					S6: shadowDetails.S6, // ? shadowDetails.S6 : false,
					S7: shadowDetails.S7, // ? shadowDetails.S7 : false,
					SA: shadowDetails.SA, // ? shadowDetails.SA : "50",
					SF: shadowDetails.SF, // ? shadowDetails.SF : "50",
					SE: shadowDetails.SE, // ? shadowDetails.SE : "50",
				},
			},
		() => console.log("Device Settings - this.state.inputs ", this.state.inputs));
		}
	}

	handleSave = () => {
			// update to AWS things!
			this.perform(this.state.inputs);
	}

	perform = (inputs) => {
		const body = {
			S1: inputs.S1,
			S2: inputs.S2,
			S3: inputs.S3,
			S4: inputs.S4,
			S5: inputs.S5,
			S6: inputs.S6,
			S7: inputs.S7,
			SA: inputs.SA,
			SF: inputs.SF,
			SE: inputs.SE,
		};

		this.setState({
			loading: true,
		})

		post(`${ControlPanelPostIP}/${this.state.deviceId}`, body)
			.then(res=> {
				this.setState({
					loading: false,
				},() => {
					// redirect if success
					push({ mobile: "Home", web: "/" }, this.props, true);
				});
			})
			.catch(err => {
				if (err.message == "Failed to fetch") {
					console.error(err);
					return;
				}

				if (err.status === 403 || err.status === 503) {
					console.log("4/503 Refresh Requested");
					refresh()
						.then(res => {
							console.log("Refresh Response : ", res);
							this.initDevice();
							return;
						})
						.catch(err => {
							console.error(err.message);
							this.logout();
						});
				}
				// err.json().then(res => {
					// if (res.message === "Unauthorized") {
					// 	refresh()
					// 		.then(resp => {
					// 			this.perform();
					// 			return;
					// 		})
					// 		.catch(err => {
					// 			console.log(err);
					// 			this.logout();
					// 		});
					// }
					// if (res.message === "Identity token has expired") {
					// 	refresh()
					// 		.then(resp => {
					// 			this.perform();
					// 			return;
					// 		})
					// 		.catch(err => {
					// 			console.log(err);
					// 			this.logout();
					// 		});
					// }
				 // });
				this.setState({
					loading: false,
				});
			});
	}

	goBack() {
		push({ mobile: "Home", web: "/" }, this.props, true);
	}

	render() {
		const { inputs } = this.state;
		console.log("Render ", inputs);

		const { t } = this.props;

		return (
			<ViewScroll>
				<View style={[x.mb.three]}>
					<Header>{t("labels.deviceSetting")}</Header>
				</View>
				<View style={[x.my.three]}>

						<View style={[x.my.one]}>
							<Select
								native
								label={t("labels.S1")}
								data={range(0,8)}
								value={inputs.S1}
								onChange={element =>
									this.setState({
										inputs: { ...inputs, S1: element.target.value },
									})
								}
							/>
						</View>

					<View style={[x.my.one]}>
						<Checkbox
							label={t("labels.S2")}
							value={inputs.S2}
							onValueChange={value =>
								this.setState({
									inputs: { ...inputs, S2: value },
								})
							}
						/>

					</View>
					<View style={[x.my.one]}>
						<Select
							native
							label={t("labels.S3")}
							value={inputs.S3}
							data={range(1,73)}
							onChange={element =>
								this.setState({
									inputs: { ...inputs, S3: element.target.value },
								})
							}
						/>

					</View>
					<View style={[x.my.one]}>
						<Checkbox
							label={t("labels.S4")}
							value={inputs.S4}
							onValueChange={value =>
								this.setState({
									inputs: { ...inputs, S4: value },
								})
							}
						/>
					</View>

					<View style={[x.my.one]}>
						<Select
							native
							label={t("labels.S5")}
							value={inputs.S5}
							data={range(1,16)}
							onChange={element =>
								this.setState({
									inputs: { ...inputs, S5: element.target.value },
								})
							}
						/>
					</View>

					<View style={[x.my.one]}>
						<Checkbox
							label={t("labels.S6")}
							value={inputs.S6}
							onValueChange={value =>
								this.setState({
									inputs: { ...inputs, S6: value },
								})
							}
						/>
					</View>

					<View style={[x.my.one]}>
						<Checkbox
							label={t("labels.S7")}
							value={inputs.S7}
							onValueChange={value =>
								this.setState({
									inputs: { ...inputs, S7: value },
								})
							}
						/>
					</View>

					<View style={[x.my.one]}>
						<Select
							native
							label={t("labels.SA")}
							select value={inputs.SA}
							data={range(50,101)}
							onChange={element =>
								this.setState({
									inputs: { ...inputs, SA: element.target.value },
								})
							}
						/>
					</View>

					<View style={[x.my.one]}>
						<Select
							native
							label={t("labels.SF")}
							select value={inputs.SF}
							data={range(50,101)}
							onChange={element =>
								this.setState({
									inputs: { ...inputs, SF: element.target.value },
								})
							}
						/>
					</View>

					<View style={[x.my.one]}>
						<Select
							native
							label={t("labels.SE")}
							select value={inputs.SE}
							data={range(50,101)}
							onChange={element =>
								this.setState({
									inputs: { ...inputs, SE: element.target.value },
								})
							}
						/>
					</View>

					<View style={[x.mt.one]}>
						<Button
							disabled={this.state.loading}
							title={t("labels.save")}
							color={x.colors.default}
							onPress={this.handleSave}
						/>
						<Button
							disabled={this.state.loading}
							onPress={() => this.goBack()}
							title={t("labels.cancel")}
							color={"#A1D9DA"}
						/>
					</View>
				</View>
			</ViewScroll>
		);
	}
}

export default translate()(DeviceSetting);



// WEBPACK FOOTER //
// ./src/views/DeviceSetting/index.js